
<div>
  <div class="min-h-screen bg-gray-100">
    <slot></slot>

    <toast></toast>
  </div>
  
</div>
